<template>
  <div id="bannerComponent">
    <div class="banner-wrapper" :class="bannerCollapse()">
      <div class="banner-content">
        <div class="banner-sider">
          <div class="banner-sider-img"></div>
          <div class="banner-sider-main">
            <div class="banner-sider-content">
              <h3 class="banner-title" v-if="isExpand">In-depth tips and analysis from a team of data and analytics experts.</h3>
              <h3 class="banner-title banner-title-collapse" v-if="!isExpand">In-depth tips and analysis from a team of data and analytics experts.</h3>
              <p class="banner-txt" v-if="isExpand">We aim to provide fans with industry-leading live game data and scientific algorithms to predict results and help you win more.</p>
              <div class="banner-btn">
                <!-- <a @click="onChangLogin(true)" class="banner-btn-sign" v-if="LoginBtnShow()">Log in</a> -->
                <router-link to="/about" class="banner-btn-more" v-if="isExpand">Learn More</router-link>
                <a class="banner-btn-what" v-if="false" @click="algoPopClose(true)">What are the algorithms we use?</a>
              </div>
            </div>
          </div>
        </div>
        <div class="algo-info-wrap">
          <div class="algo-info-content">
            <div class="algo-pop-wrap">
              <div class="algo-pop-content">
                <div class="algo-pop-title">{{ langConfig.algo[langConfig.curLang]['TITLE'] }}</div>
                <div class="algo-pop-tab">
                  <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['MODEL_TITLE']">
                    <span :class="[{on: algoTab == index}]" :key="index" @click="algoTabFn(index)">{{ item }}</span>
                  </template>
                </div>
                <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['MODEL_TITLE']">
                  <div class="algo-pop-box" :key="index" v-if="algoTab == index">
                    <div class="algo-pop-info">
                      <p>{{ langConfig.algo[langConfig.curLang]['INFO'][index] }}</p>
                      <div class="algo-play-box" v-if="algoTab == 0">
                        <div class="algo-play-title">Prediction Types:</div>
                        <div class="algo-play-item">
                          <p><span>Correct Scores</span><b>Predict the score after 90 minutes, providing 3 results with the highest algorithm prediction probability.</b></p>
                          <p><span>Goals</span><b>Predict the goals of the whole game, providing the 2 results with the highest algorithm prediction probability.</b></p>
                        </div>
                      </div>
                      <div class="algo-play-box" v-if="algoTab == 1">
                        <div class="algo-play-title">Prediction Types:</div>
                        <div class="algo-play-item">
                          <p><span>1x2</span><b>Predict the 90-minute full-time result, and provide a confidence index for reference. The more stars, the higher the confidence.</b></p>
                        </div>
                      </div>
                      <div class="algo-play-box" v-if="algoTab == 2">
                        <div class="algo-play-title">Prediction Types:</div>
                        <div class="algo-play-item">
                          <p><span>1x2</span><b>Predict the 90-minute full-time result.</b></p>
                          <p><span>Asian Handicap</span><b>redict the 90-minute full-time result for the Asian Handicap.</b></p>
                          <p><span>Goals Over/Under</span><b>Predict the 90-minute full-time result for the Over/Under.</b></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <template v-for="(item, index) in statArr">
                <div class="algo-stat-box" :key="index" v-if="algoTab == index && homeSate[item]">
                  <div class="algo-stat">
                    <div class="algo-stat-item">
                      <div class="algo-stat-num">{{ homeSate[item]['predCountRe30'] || 0 }}</div>
                      <div class="algo-stat-title">Last 30 days</div>
                    </div>
                    <div class="algo-stat-item">
                      <div class="algo-stat-num">{{ homeSate[item]['predCountToday'] || 0 }}</div>
                      <div class="algo-stat-title">Today</div>
                    </div>
                    <div class="algo-stat-item" v-if="predProfitRe30IsShow(homeSate[item]['predProfitRe30'])">
                      <div class="algo-stat-num">{{ homeSate[item]['predProfitRe30'] || '0%' }}</div>
                      <div class="algo-stat-title">Last 30-day Yield</div>
                    </div>
                  </div>
                  <div class="algo-pre-box">
                    <div class="algo-pre-title">Predicted league records:</div>
                    <ul class="algo-pre-list">
                      <li v-for="(rankItem, rankIndex) in homeSate[item]['rankList']" :key="rankIndex">
                        <div class="pre-logo"><span class="logo"><img :src="common.leagueImgGet(rankItem['leagueId'], 20)" @error="common.imgError($event, 'team')" /></span></div>
                        <div class="pre-name">{{ homeSate[item]['rankLeagueInfo'][rankItem['leagueId']]['fullName'] }}</div>
                        <div class="pre-stat">LAST <span class="green">{{ rankItem['lastCount'] }}</span> HIT <span class="red">{{ rankItem['hitrate'] }}</span> YIELD <span class="red">{{ rankItem['profit'] }}</span></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <i class="banner-ext" :class="isExpand ? '' : 'ext-collapse'" @click="expandClick()"></i>
    </div>
    <van-popup v-model="algoshow" class="van-popup-m"
    closeable
    close-icon="close"
    @closed="algoPopClose(false)" :position="screenWidth>767?'center':'bottom'" get-container="#app">
      <div class="algo-pop-wrap">
        <div class="algo-pop-content">
          <div class="algo-pop-title">{{ langConfig.algo[langConfig.curLang]['TITLE'] }}</div>
          <div class="algo-pop-tab">
            <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['MODEL_TITLE']">
              <span :class="[{on: algoTab == index}]" :key="index" @click="algoTabFn(index)">{{ item }}</span>
            </template>
          </div>
          <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['MODEL_TITLE']">
            <div class="algo-pop-box" :key="index" v-if="algoTab == index">
              <div class="algo-pop-img"><img :src="algoImgBack(index)" /></div>
              <div class="algo-pop-info">
                <p>{{ langConfig.algo[langConfig.curLang]['INFO'][index] }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>

	export default {
    name: 'banner',
    components: {
    },
    
    props: {
      homeSate: {
        type: Object,
        default: () => {}
      },
      loginInfoShow: {
        type: Boolean,
        default: () => false
      }
    },

		data(){
			return{
        isExpand: true, //是否展开
        loginShow: false, // 登录弹窗

        algoshow: false, // 算法弹窗
        algoTab: 0,

        statArr: ['poisson', 'margin' ,'diff'],

        screenWidth:2000,
      }
		},

    computed: {
      
    },

    mounted(){
      this.screenWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize);
    },

		methods:{
      LoginBtnShow(){
        if(!this.loginInfoShow){
          let eventName = 'LS_PC_H_Login';
          if(this.common.isMobile != 4){
              eventName = 'LS_Webapp_H_Login';
          }

          this.common.googleEvent(eventName, {
              '触发位置': '首页大图登录按钮'
          });

          return true;
        }

        return false;
      },

      // 样式
      bannerCollapse(){
        if(!this.isExpand){
          return 'banner-collapse';
        }else{
          if(this.screenWidth <= 767){
            return 'algoTab_' + this.algoTab;
          }
          return '';
        }
      },

      // 展开收起
      expandClick() {
        this.isExpand = !this.isExpand;

        setTimeout(function(){
          window.scrollBy(0, 1);
        }, 500)
        if(!this.isExpand){ // 收起存storage
          //this.common.infoStorage('bannerExpand', 0);
        }
      },

      // banner初始化
      expandInit(){
        let _isExpand = this.common.getStorage('bannerExpand');

        if((_isExpand != null && _isExpand*1 == 0) || this.loginInfoShow){
          this.isExpand = false;
        }
      },
      // 登录弹窗
      onChangLogin(val){
        let _val = val;
        this.loginShow = _val;
        this.$emit('onChangLogin', {
          loginShow: this.loginShow,
          loginInfoShow: false
        });
      },

      // 算法弹窗
      algoPopClose(val){
        this.algoshow = val;
      },

      algoTabFn(val){
        let _val = val;
        this.algoTab = _val;
      },

      // 算法图片返回
      algoImgBack(index){
        let _index = index;
        return require('@/assets/images/algo-img-' + _index + '.jpg');
      },

      // 是否显示盈利率
      predProfitRe30IsShow(val){
        let _val = val;
        if(_val){
          let _fit = _val.replace('%', '')*1;
          if(_fit < 0){
            return false;
          }
          return true;
        }

        return false;
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },
		},

		created(){
      this.expandInit();
		},

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    destroyed() {
      
    },

    watch: {
      loginInfoShow: {
        immediate: true,
        deep: true,
        handler(val){
          this.expandInit();
        }

      }
    },
	};

</script>
<style lang="less" scoped>
@import '~@/style/index/banner.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/components/banner.vue